import React from 'react';
import Launch from '@mui/icons-material/Launch';


const Link = ({
	url,
	label,
	style = {},
}) => {
	return (
		<a href={url} target="_blank" rel="noreferrer" style={{
			marginBottom: 12,
			width: '100%',
			border: '1px solid rgba(0, 0, 0, 0.23)',
			backgroundColor: 'rgba(0, 0, 0, 0.05)',
			padding: '16.5px 14px',
			borderRadius: '4px',
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			color: '#1976d2',
			...style,
		}}>
			<Launch /><span style={{ paddingLeft: '0.5rem' }}>{label || url}</span>
		</a>
	);
};

Link.type = 'Link';
Link.spec = [{
	name: 'Link',
	key: 'Link',
	category: 'layout',
	title: 'Link',
	icon: 'ExternalLink',
	translatable: ['label', 'url'],
	fields: [{
		type: 'TextField',
		label: 'Link',
		name: 'url',
	}, {
		type: 'TextField',
		label: 'Link text',
		name: 'label',
	}],
}];

export default Link;